<template>
  <div>
    <div v-if="reviewPlanParam.init === 1">
      <message :messages="messages"></message>
      <div class="elevation-1">
        <table class="v-datatable v-table theme--light planTable">
          <thead class="planHeader">
            <tr>
              <th class="limitTxtHeader">
                <div class="planHeaderCol" v-if="travelType">
                  <!-- Reserved for Travel-->
                  <div v-if="travelType === 'I'">
                    <v-icon large>mdi-account</v-icon>
                    <h2>Individual</h2>
                  </div>
                  <div v-else-if="travelType === 'F'">
                    <v-icon large>mdi-account-group</v-icon>
                    <h2>Family</h2>
                  </div>
                </div>
              </th>
              <th>
                <div class="planHeaderCol text-xs-center">
                  <div class="ribbon" v-if="$store.state.agency.quotation.commonInfo.premium.discPct && $store.state.agency.quotation.commonInfo.premium.discPct > 0">
                    <span class="ribbontitle">{{$store.state.agency.quotation.commonInfo.premium.discPct}}% OFF!</span>
                  </div>
                  <div class="planTitle">
                    {{plan.planDesc}}
                  </div>
                  <div class="mt-2">
                    <span class="planCurr primary--text">{{currPrefix}}</span>
                    <span class="planPrice primary--text">{{formatDisplayNumber($store.state.agency.quotation.commonInfo.premium.premiumPayable)}}</span>
                  </div>
                  <div v-if="plan.premium && plan.premium.promotion">
                    {{plan.premium.promotion}}
                  </div>
                  <div v-else>
                    &nbsp;
                  </div>
                  <v-btn color="primary" @click.prevent="doProceed" :loading="reviewPlanParam.init === 0" :disabled="reviewPlanParam.init === 2">
                    Proceed
                    <v-icon right>mdi-chevron-right</v-icon>
                  </v-btn>
                </div>
              </th>
            </tr>
          </thead>
          <tbody class="planBody">
            <tr v-for="limit in limitsText" :key="limit.value" :class="limit.main? 'titleRow' : ''">
              <td>
                <div class="planCol">
                  <span v-html="formatHtml(limit.label)"></span>
                </div>
              </td>
              <td class="text-xs-center">
                <div class="planCol">
                  <template v-if="plan.limits[limit.value]">
                    <template v-if="plan.limits[limit.value].strValue">
                      <span>{{plan.limits[limit.value].strValue}}</span>
                    </template>
                    <template v-else-if="plan.limits[limit.value].uomUN && plan.limits[limit.value].uomUN !== ''">
                      <span>{{getUomUN(plan.limits[limit.value].uomUN)}}</span>
                    </template>
                    <template v-else-if="plan.limits[limit.value].isSI">
                      <!-- For SI, show currPrefix and format Number -->
                      <span v-if="plan.limits[limit.value].uomAmt">{{currPrefix + formatDisplayNumber(plan.limits[limit.value].uomAmt, 0)}}</span>
                      <span v-else>{{currPrefix + '0'}}</span>
                    </template>
                    <template v-else>
                      <span v-if="plan.limits[limit.value].uomAmt">{{formatDisplayNumber(plan.limits[limit.value].uomAmt, 0)}}</span>
                      <span v-else>0</span>
                    </template>
                  </template>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <loader v-else :height="300" :init="doInit" loadText="Checking your selected plan ..." errorText="Failed to verify your selected plan" :loading="reviewPlanParam.init === 0" :errorMsgs="reviewPlanParam.initErr"></loader>
  </div>
</template>

<script>
import { formatDisplayNumber } from '@/utils/number'
import MessageMixin from '@/mixins/message'
import { uomUN } from '@/const/underwriting/package'

export default {
  data() {
    return {
      selected: null,
      selectedAmt: null,
      adjDialog: false
    }
  },
  computed: {
    commonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    currPrefix() {
      return this.$store.state.agency.quotation.commonInfo.currPrefix
    }
  },
  methods: {
    async doInit() {
      if (this.reviewPlanParam.init !== 1) {
        // Do a recalculate
        await this.$store.dispatch(this.recalcMethodName)
      }
    },
    formatHtml(text) {
      // Replace /r/n with html br
      return text.replace(new RegExp('\\r?\\n', 'g'), '<br />')
    },
    formatDisplayNumber(xNum, scale = 2) {
      return formatDisplayNumber(xNum, scale)
    },
    getUomUN(val) {
      if (val && uomUN[val]) {
        return uomUN[val]
      }
      return ''
    },
    doProceed() {
      this.$emit('proceed')
    }
  },
  mounted() {
    this.doInit()
  },
  props: {
    plan: {
      type: Object,
      default: () => { }
    },
    limitsText: {
      type: Array,
      default: () => []
    },
    recalcMethodName: {
      type: String,
      default: null
    },
    reviewPlanParam: {
      type: Object,
      default: () => { }
    },
    travelType: {
      type: String,
      default: null
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style lang="scss">
.planAction {
  width: 50px;
}
</style>
